

interface IApiHelperArgs {
  resource:string 
  id?:string|number|null|undefined
  data?:any
  config?: {
    prefix?:string
    path?:string
    method?:string 
    onSuccess?:(result:any) => any
    onError?:(result:any) => any
  }
  params?:{
    _page?:number
    _perpage?:number
    _sortby?:string
    _sortdir?:string
    [key:string]:any
  }
}


const determineIdValue = (args:any) => {
  // console.log(args)
  if( args._id || args.id ){
    return args._id || args.id
  } else if( args.data?.id || args.data?._id ){
    return args.data?.id || args.data?._id
  } else {
    return null
  }
}


const generateApiPath = (operation:string, args:any) => {
  let path = (!args.config?.path) ? `/api/${args.resource}` : args.config.path
  const id = determineIdValue(args)
  // console.log("id", id)
  if( id ){
    path = `${path}/${id}`
  }
  // console.log(path)
  return path
}

const generateQueryParams = (displayParams:any = {}, filters:any={}) => {
  let finalStr = ""
  finalStr += Object.entries(displayParams).map(([key, value]) => `${key}=${value}`).join("&")
  finalStr += Object.entries(filters).map(([key, value]) => `${key}=${value}`).join("&")
  // console.log("finalStr", finalStr)
  return finalStr.length ? `?${finalStr}` : finalStr
}

const generateQueryParamsOld = (operation:string, args:any) => {
  // console.log(args)
  let params = ""
  const queryParams = Object.entries(args || {})
    .filter( (key:any) => !key.startsWith("_") )
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

    if( operation === "findOne" ){
      console.log("args", args)
    }

  if (queryParams) {
    params = `?${queryParams}`;
  }

  if (operation === "findAll" && args._paginate === true) {
    const _page = args?._page || 1;
    const _perpage = args?._perpage || 25;
    const _sortby = args?._sortby;
    const _sortdir = args?._sortdir;

    let additional = `_paginate=true&_page=${_page}&_perpage=${_perpage}`
    if( _sortby ){
      additional += `&_sortby=${_sortby}&_sortdir=${_sortdir || "asc"}`
    }
    params += params ? `&${additional}` : `?${additional}`;
  }

  return params;
}

const buildFetchOptions = (method:string, data:any) => {
  if( method === "GET" ) return {}
  return {
    method: method,
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  }
} 

// const buildFetchQuery = (operation:string, args:any, method:string) => {
//   const path = generateApiPath(operation, args)
//   const params = generateQueryParams(operation, args)
//   const opts = buildFetchOptions(operation, args, method)
//   return { path, params, opts }
// }

const runQuery = async({op, path, params, data, config}:{op:string; path:string; params:string, data?:any; config?:any}) => {
  let method:any 
  if( op === "findAll" || op === "findOne" || op === "findById" ){
    method = "GET"
  } else if( op === "create" ){
    method = "POST"
  } else if( op === "updateById" ){
    method = "PUT"
  } else if( op === "deleteById" ){ 
    method = "POST"
  }

  const opts = buildFetchOptions(method, data)
  const url = `${path}${params}` 

  try {
    const response = await fetch(url, opts)
    if( !response.ok ){
      throw new Error(`Error: ${response.statusText}`)
    }
    data = await response.json()

    if( config?.onSuccess ){
      return config.onSuccess(data || {})
    }

    if( op === "findOne"){

      if( data.payload && data.payload.length > 0 ){
        return data.payload[0]
      } else if ( data && data.length > 0 ){
        return data[0]
      } else {
        return data
      }
    }


    return (data.payload) ? data.payload : data
  } catch (error) {
    console.error("Error fetching data:", error)
    if( config?.onError ){
      return config.onError(error)
    }
    throw error
  }
}



export async function findAll({ resource, displayParams, filters, config }:{ resource:string; displayParams:any; filters:any; config?:any }){
  const path = `/api/${resource}`
  const params = generateQueryParams(displayParams, filters)
  return await runQuery({ op: "findAll", path, params })
}

export async function findOne({ resource, displayParams, filters, config }:{ resource:string; displayParams:any; filters:any; config?:any }){
  const path = `/api/${resource}`
  const params = generateQueryParams(displayParams, filters)
  return await runQuery({ op: "findOne", path, params })
}

export async function findById({ resource, idObj, config }:{ resource:string; idObj:any; config?:any }){
  const path = `/api/${resource}/${idObj.value}`
  const params = generateQueryParams()
  return await runQuery({ op: "findById", path, params, config })
}

export async function create({ resource, data, config }:{ resource:string; data:any; config?:any }){
  const path = `/api/${resource}`
  const params = generateQueryParams()
  return await runQuery({ op: "create", path, params, data, config })
}

export async function updateById({ resource, idObj, data, config }:{ resource:string; idObj:any; data:any; config?:any }){
  const path = `/api/${resource}/${idObj.value}`
  const params = generateQueryParams()
  return await runQuery({ op: "updateById", path, params, data, config })
}

export async function save({ resource, idObj, data, config }:{ resource:string; idObj?:any; data:any; config?:any }){
  if( idObj && idObj.value ){
    return await updateById({ resource, idObj, data, config })
  } else {
    return await create({ resource, data, config })
  }
}

export async function remove({ resource, idObj, config }:{ resource:string; idObj:any; config?:any }){
  const path = `/api/${resource}/delete`
  const params = generateQueryParams({}, {})
  const data = { id: idObj.value }
  return await runQuery({ op: "deleteById", path, params, data, config })
}